/* Egyetlen pénzformázó az egész boltra.

   MIÉRT EGY HELYEN: ugyanaz a hiba háromszor jött elő ugyanabból az
   okból. A `toLocaleString('hu-HU')` a NÉGYJEGYŰ számokat nem tagolja
   (1600 -> "1600"), mert a magyar CLDR-ben a minimumGroupingDigits 2.
   A bolt money_formatja viszont tagol ("1.600 Ft"), így minden olyan
   helyen, ahol JS írta felül az árat, más szám állt, mint a Liquid
   által rendereltek mellett:
     - termékkártya / terméklap egységára (Ft/kg)
     - „Gyakran együtt vásárolt" összege
     - tapadó kosársáv ára

   A bolt formátuma: {{amount_no_decimals_with_comma_separator}} Ft
   -> ezres elválasztó PONT, tizedes nincs.

   A globálist a footer tölti be egyszer, minden oldalon. A kezdeti
   értékeket továbbra is a Liquid `| money` adja — ez a függvény csak
   a JS-ből jövő FRISSÍTÉSEKHEZ kell (variánsváltás, jelölés, append). */
(function () {
  'use strict';

  function groupThousands(intValue) {
    var digits = String(Math.abs(intValue));
    var out = '';
    for (var i = 0; i < digits.length; i++) {
      if (i > 0 && (digits.length - i) % 3 === 0) out += '.';
      out += digits[i];
    }
    return (intValue < 0 ? '-' : '') + out;
  }

  // A Shopify centben tárol: 160000 -> "1.600 Ft"
  function formatHuf(cents) {
    var ft = Math.round((Number(cents) || 0) / 100);
    return groupThousands(ft) + ' Ft';
  }

  // Már forintban lévő értékhez (pl. számított egységár)
  function formatHufAmount(amount) {
    return groupThousands(Math.round(Number(amount) || 0)) + ' Ft';
  }

  /* A kiszerelés a variáns/opció nevéből jön ("250g", "1 kg"), mert a
     Shopify natív egységár-mezője (unit_price_measurement) nincs kitöltve,
     a megadott súly pedig a CSOMAGOLT bruttó tömeg (250 g méz = 275 g),
     amiből 9%-kal alacsonyabb kilóár jönne ki, mint amit az oldal máshol
     mutat. Ezért a névből számolunk — de EGY helyen.

     Ez a parsolás korábban két külön másolatban élt (blocks/price.liquid
     és blocks/pm-unit-saving.liquid), és a méretválasztóhoz kellett volna
     egy harmadik. Ugyanaz a minta, amiért a formatHuf is ide került.

     A mintában SZÁNDÉKOSAN nincs \b: a {% javascript %} blokkokat a
     Shopify minifikálva fűzi a block-scripts.js-be, és ott a \b valódi
     backspace karakterré vált. Itt, assetben ez nem fenyeget, de a minta
     egy helyen él, hogy a változatok ne csúszhassanak szét. */
  /* 2026-09-30: ml / l is (propolisz tinktúra, 50 ml) — a 4/2009. NFGM–SZMM r.
     szerint folyadéknál literenkénti egységár kell. A `grams` mező ilyenkor
     milliliter, a `base` mondja meg, mire vetítünk ('kg' vagy 'l'). A minta
     sorrendje számít: a „kg”-t a „g” előtt, az „ml”-t az „l” előtt kell próbálni. */
  function parseSize(title) {
    var m = String(title == null ? '' : title).match(/(\d+(?:[.,]\d+)?)\s*(kg|g|ml|l)(?![a-z])/i);
    if (!m) return null;
    var value = parseFloat(m[1].replace(',', '.'));
    if (!isFinite(value) || value <= 0) return null;
    var unit = m[2].toLowerCase();
    var liquid = unit === 'ml' || unit === 'l';
    return {
      label: m[1].replace('.', ',') + ' ' + unit,
      grams: (unit === 'kg' || unit === 'l') ? value * 1000 : value,
      base: liquid ? 'l' : 'kg'
    };
  }

  // Kilóár a variáns árából (centben) és a nevéből. Üres string, ha nem
  // számolható — a hívó ilyenkor ne írjon ki semmit.
  function perKg(cents, title) {
    var size = parseSize(title);
    if (!size || !cents) return '';
    return formatHufAmount(Number(cents) / size.grams * 1000 / 100) + ' / ' + size.base;
  }

  window.pmMoney = {
    formatHuf: formatHuf,
    formatHufAmount: formatHufAmount,
    groupThousands: groupThousands,
    parseSize: parseSize,
    perKg: perKg
  };
})();
